import { TaxDocumentSection } from './TaxDocumentSection';
export default TaxDocumentSection;
